import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
      path: '/guestbook',
      name: 'GuestBook',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/GuestBook.vue')
    },
    {
      path: '/guestbook/post',
      name: 'GuestBookPost',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/GuestBookPost.vue')
    },
    {
      path: '/guestbook/:postId',
      name: 'GuestBookContent',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/GuestBookContent.vue')
    },
    {
      path: '/news',
      name: 'History',
      component: () => import('../views/History.vue')
    },
    {
      path: '/news/publish',
      name: 'HistoryPost',
      component: () => import('../views/HistoryPost.vue')
    },
    {
      path: '/photo',
      name: 'Photo',
      component: () => import('../views/PhotoGroup.vue')
    },
    {
      path: '/photo/post',
      name: 'PhotoPost',
      component: () => import('../views/PhotoPost.vue')
    },
    {
      path: '/photo/:groupId',
      name: 'PhotoGroup',
      component: () => import('../views/Photo.vue')
    },
    {
      path: '/photo/:groupId/p/:photoId',
      name: 'PhotoShow',
      component: () => import('../views/PhotoShow.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue')
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('../views/Logout.vue')
    },
    {
      path: '/account',
      name: 'AccountInfo',
      component: () => import('../views/AccountInfo.vue')
    },
    {
      path: '/account/update',
      name: 'AccountInfoUpdate',
      component: () => import('../views/AccountInfoUpdate.vue')
    },
    {
      path: '*',
      name: 'Home',
      component: Home
    }
  ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
